/**
 * @classdesc オブジェクト系のユーティリティクラス
 */
export default class ObjUtils {

    /**
     * オブジェクトを深いネストでマージ（非破壊）
     * @param {Object} target - マージ元オブジェクト
     * @param {Object} src - マージ先オブジェクト
     * @returns {Object} マージ後の新しいオブジェクト
     */
    static deepMerge(target, src) {
        const clone = structuredClone(target);

        for (const key in src) {
            if (src.hasOwnProperty(key) && typeof src[key] === 'object' && src[key] !== null && !Array.isArray(src[key])) {
                if (!clone[key] || typeof clone[key] !== 'object') {
                    clone[key] = {};
                }
                clone[key] = this.deepMerge(clone[key], src[key]);
            } else {
                clone[key] = src[key];
            }
        }

        return clone;
    }
}
